import LniChildLaborComplaintConfirmation from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-confirmation';
import LniChildLaborComplaintContact from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-contact';
import LniChildLaborComplaintDocuments from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-documents';
import LniChildLaborComplaintEmployer from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-employer';
import LniChildLaborComplaintForm from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-form';
import LniChildLaborComplaintInformation from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-information';

export default [
    LniChildLaborComplaintConfirmation,
    LniChildLaborComplaintContact,
    LniChildLaborComplaintDocuments,
    LniChildLaborComplaintEmployer,
    LniChildLaborComplaintForm,
    LniChildLaborComplaintInformation,
];